import { atom } from "jotai";
import { Node } from "@xyflow/react";
import { atomFamily } from "jotai/utils";

import { nodesAtom } from "./nodesAtom";
import { NodeData } from "../types";

export const nodeAtomFamily = atomFamily((nodeId: string) => {
  const nodeAtom = atom((get) => {
    const nodes = get(nodesAtom);
    return nodes.find(({ id }) => id === nodeId) as Node<NodeData>;
  });

  nodeAtom.debugLabel = `nodeAtomFamily(${nodeId})`;
  return nodeAtom;
});
